export default {
    container: { display: 'flex', height: '100%', flexDirection: 'column', flex: 1 },
    headerContainer: {
        backgroundColor: '#fff'
    },
    logoContainer: {
        display: 'flex',
        justifyContent: 'center',
        padding: '20px 40px'
    },
    logo: { height: 35, marginBottom: 8 },
    pageTitle: { textAlign: 'center', margin: 40, marginTop: 20 },
    pageContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'flex-start',
        flex: 1,
        background: '#f4f4f4'
    },
    panelContainer: { width: '100vw', maxWidth: 560 },
    contentContainer: { padding: 30 },
    inputContainer: { padding: '10px 0px' },
    resetButtonContainer: { display: 'flex', justifyContent: 'flex-end', padding: '10px 0px' },
    resetButton: { width: '100%' },
    successDialogContainer: { width: '100vw', maxWidth: 560, padding: 30, textAlign: 'center' }
};
